import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType, Window508Type } from "../CalmBaseScenario";
import Scenario4 from "./Scenario4";

export default class Scenario4Part8 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 1;
	chapterIds = {
		scenario4_2C_s14: 'CALM - Scenario 4 - 2C - Segment 14',
		scenario4_2C_s15: 'CALM - Scenario 4 - 2C - Segment 15',
	}

	constructor(scenario: Scenario4, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario4/calm-scenario4-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario4.parts.level4Part8.id;
	}

	public start() {
		const context = this;
		context.segment1Step1IncomingCall();
	}

	private segment1Step1IncomingCall() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.playVideoChapter(this.chapterIds.scenario4_2C_s14, () =>
			context.segment1Step2Dialogue())
	}

	private segment1Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;		
		context.scenario.updateObjective('');
		this.scenario.dialog(
			'CN-C10-L3-030b',
			[{
				text: 'It seems you followed the checklist, so go ahead and discharge him.',				
				scoreType: ScoreType.Zero,
				isCorrect: true // Rank zero (no points awarded)
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here
				context.scenario.evaluateAnswer(selectedOption, () => context.segment2Step1MirandaResponds(), context.partIndx);
			}
		);
	}

	private segment2Step1MirandaResponds() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.playVideoChapter(context.chapterIds.scenario4_2C_s15, () => {
			context.segment3Step1GoToNSC();
		});
	}

	private segment3Step1GoToNSC() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: [
				{
					title: 'Incident',
					description: 'In this scenario, the discharge followed procedures without incident. No data is added to this report.'
				},
				{
					title: '24 Hour',
					description: 'This was added to the report: Patient discharged without incident (foot infection from Diabetic Neuropathy). '
				},
				{
					title: 'End of Shift',
					description: 'This was added to the report: Patient discharged without incident (foot infection from Diabetic Neuropathy). '
				}
			],
			review: {
				text: 
				`
				<p class="regular-description-font" style="margin: 0">
					Patient discharge requires many tasks be accomplished such as <span style="color: rgb(222, 225, 156)">making follow-up appointments, providing 
					wound care instructions and materials, </span>and taking an <span style="color: rgb(222, 225, 156)">MRSA nasal swab. </span><br /><br />
					It is important to check the <span style="color: rgb(222, 225, 156)">CPRS for any doctor’s orders </span>or other standing orders such as for 
					influenza and pneumococcal pneumonia vaccinations. <br /><br />
					Additionally, your unit may require that <span style="color: rgb(222, 225, 156)">specific discharge criteria be met </span>such as a BP below 
					140 over 80 for diabetic patients like Mr. Zolic. <br /><br />
					As a Charge Nurse, <span style="color: rgb(222, 225, 156)">ask your staff if they have met all of the needs outlined in the CPRS and the Unit 
					Discharge Checklist, </span>ensuring that the IV was removed, extra supplies provided, or other things as appropriate for the patient. 
				</p>
				`
			},
			reflects: [
				{
					title: 'Do you have a discharge checklist for your unit? What’s on it?',
					answer: ''
				},
				{
					title: 'What are the roles and responsibilities for patient discharge in your unit?',
					answer: ''
				},
				{
					title: 'What are your current discharge policies and procedures?',
					answer: ''
				},
				{
					title: 'What other interdisciplinary services does your unit have available?',
					answer: ''
				},
				{
					title: 'What would have happened if Mr. Zolic had a fever or high blood pressure? How would this be handled at your facility?',
					answer: ''
				}
			],
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.partEnd();
			} 
		})
	}

	private partEnd() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].points = CalmBaseScenario.scores[this.partIndx];

		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].isUnlocked = true;
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;

		this.scenario.gameManager.customData.saveGame(this.scenario.gameManager);

		this.scenario.showBadgingUI(context.partIndx, () => {
			context.onDone();
		});
	}
}